import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
const popins =Poppins({weight:"500",subsets:['latin']})
const quickSand =Quicksand({weight:"500",subsets:['latin']})
export default function LearnSoftLogo({title,location1}) {
  return (
    <>
    
    <section>
<div className='container'>
<div className='logo-bg mt40'>
   <div className='df fac fjc pdt40 fdc'>
    <Image src={"/course-img/logo.webp"} alt={`${title}${location1}`} width={"111"} height={"138"} loading='lazy'/>
    <h6 className={`fs-20 mfs- pdt40 cw ${popins.className}`}>Begin your self-investment<br/> journey today.</h6>

    <button className={`strt-now-btn mt40 cw ${quickSand.className}`}> <Link className='cw' href={"tel:+917825888899"}> Start Now </Link> </button>
  
   </div>
</div>
</div>
    </section>
    
   <style jsx>
    {`
    .strt-now-btn{
      padding: 8px 24px 8px 24px;
      background-color: #FDBB39;
      border-radius: 32px;
      border: none;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.5px;
      color: #FFFFFF;
      cursor: pointer;

    }
    .logo-bg{

      background-image: url('/course-img/learnsoft-img.webp');
      width: 400px;
      height: 808px;
      border-radius: 30px;
      text-align: center;

    }

    
    @media only screen and (max-width: 1223px){


      .strt-now-btn{
        padding: 4px 12px 4px 12px;
        background-color: #FDBB39;
        border-radius: 24px;
        border: none;
        font-size: 12px;
        line-height: 19px;
        letter-spacing: 0.5px;
        color: #FFFFFF;
        cursor: pointer;
  
      }
      .logo-bg{
  
        background-image: url('/course-img/learnsoft-img.webp');
        width: 280px;
        height: 400px;
        border-radius: 8px;
        text-align: center;
  
      }
      .logo-fs{
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.15px;
        color:#FFFFFF;
      }


    }
    
    `}
    
    
    </style> 
    
    </>
  )
}
